const checkIPAddress = (IP: string = "") => {
  if (!IP) {
    return false;
  }
  if (IP.endsWith("/")) {
    IP = IP.substring(0, IP.length - 1);
  }
  // === Remove http:// || https:// from starts IP ===
  if (IP.startsWith("http://") || IP.startsWith("https://")) {
    IP = IP.replace(/^https?:\/\//, "");
  }
  // === Remove :3030 from ends IP ===
  if (IP.endsWith(":3030")) {
    IP = IP.replace(":3030", "");
  }
  const pattern =
    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
  return pattern.test(IP);
};

export default checkIPAddress;
